import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton, BasicCheckbox, BaasicModal, BaasicFieldDropdown, BasicInput, NumericInputField } from 'core/components';
import { Content } from 'core/layouts';
import { toDate, uuid } from "core/utils";
import { FacilityOrderTemplatePNMissingInformationModal, FacilityOrderTemplateMissingDocumentNoteModal } from "application/facility-order/components";
import { FacilityOrderTemplateNewFlowCustomOrderingDoctorAdd } from "application/facility-order-new-flow/components";

function PatientMissingDocsTemplateEditTemplate({ patientMissingDocsTemplateEditViewStore, showAdditionalData }) {
    const {
        loaderStore,
        contentLoading,
        item,
        setIncludeInDocReqEmail,
        isCurrent,
        form,
        missingDocumentStore,
        facilityOrderTemplateMissingDocumentNoteModal,
        openFacilityOrderTemplateMissingDocumentNoteModal,
        isItemVisible,
        changeItemVisibility,
        updateFacilityOrderTempalte,
        generateMedicalNecessityFormAndStandardWrittenOrder,
        generateStandardWrittenOrder,
        generateMedicalNecessityForm,
        updatePatient,
        doctorStore,
        dxCode1Store,
        dxCode2Store,
        dxCode3Store,
        dxCode4Store,
        dxCode5Store,
        dxCode6Store,
        dxCode7Store,
        dxCode8Store,
        facilityOrderTemplatePNMissingInformationModal,
        facilityOrderTemplate,
        inactiveReason,
        eligibilityStatus
    } = patientMissingDocsTemplateEditViewStore;

    const tagRender = (tagData, li) => React.cloneElement(li, { children: <span key={uuid()} onClick={() => openFacilityOrderTemplateMissingDocumentNoteModal(tagData.data[0])}>{tagData.data[0].name}</span> });

    const dxCodeDropdownItemRender = (li, itemProps) => {
        const itemName = itemProps && itemProps.dataItem.name;
        const itemChildren = (
            <span style={{ display: "flex", flexDirection: "column", width: "100%", }}>
                <span style={{ flex: "1" }}> {li.props.children} </span>
                <span style={{ fontSize: "12px" }}>{itemName} </span>
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    }

    return (
        <Content loading={contentLoading || loaderStore.loading} >
            {item &&
                <React.Fragment>
                    <table className="table--secondary table--secondary--no-footer w--100">
                        <colgroup>
                            <col width={400} />
                            <col width={150} />
                            <col width={90} />
                            <col />
                        </colgroup>
                        <thead>
                            <tr>
                                <th colSpan="4" className="type--left">
                                    <div className="u-flex--default u-mar--bottom--sml">
                                        {showAdditionalData && <label className='type--color--opaque u-mar--right--tny'>DOS:</label>}
                                        <label className="type--wgt--medium">{toDate(item.facilityOrder.dateOfService)}</label>
                                        {showAdditionalData && (isCurrent ?
                                            <div className="status status--tny status--success u-display--ib u-mar--left--tny">CURRENT</div>
                                            :
                                            <div className="status status--tny status--disabled u-display--ib u-mar--left--tny">PAST</div>)
                                        }
                                        <div className="u-flex u-flex--default u-align--h--right">
                                            {inactiveReason && <div className="status status--warning status--sml u-mar--right--tny">{inactiveReason.name}</div>}
                                            <div className="status status--sml status--blue u-display--ib u-mar--right--tny">{item.clinicalStatus ? item.clinicalStatus.name : eligibilityStatus ? eligibilityStatus.name : "None"}</div>
                                            {!isCurrent &&
                                                <BasicCheckbox
                                                    id={item.id + "includeInDocReqEmail"}
                                                    checked={item.includeInDocReqEmail}
                                                    onChange={(e) => setIncludeInDocReqEmail(e.target.checked)}
                                                />
                                            }
                                        </div>
                                    </div>
                                    {(item.includeInDocReqEmail || (item.facilityOrderTemplateMissingDocuments && item.facilityOrderTemplateMissingDocuments.some(x => x)) || (facilityOrderTemplate.facilityOrderTemplateMissingDocuments && facilityOrderTemplate.facilityOrderTemplateMissingDocuments.some(x => x))) &&

                                        <div className="form__group">
                                            <BaasicFieldDropdown field={form.$('facilityOrderTemplateMissingDocuments')} store={missingDocumentStore} multi={true} tagRender={tagRender} autoClose={true} />
                                        </div>
                                    }
                                    {isItemVisible ?
                                        <React.Fragment>
                                            {!(item.includeInDocReqEmail || (item.facilityOrderTemplateMissingDocuments && item.facilityOrderTemplateMissingDocuments.some(x => x)) || (facilityOrderTemplate.facilityOrderTemplateMissingDocuments && facilityOrderTemplate.facilityOrderTemplateMissingDocuments.some(x => x))) &&

                                                <div className="form__group">
                                                    <BaasicFieldDropdown field={form.$('facilityOrderTemplateMissingDocuments')} store={missingDocumentStore} multi={true} tagRender={tagRender} autoClose={true} />
                                                </div>
                                            }
                                            <div className="row">
                                                <div className="form__group col col-lrg-7">
                                                    <BasicInput field={form.$('note')} onBlur={() => { updateFacilityOrderTempalte('note') }} />
                                                </div>
                                                <div className="form__group col col-lrg-3">
                                                    <BasicInput field={form.$('swo')} onBlur={() => { updateFacilityOrderTempalte('swo') }} />
                                                </div>
                                                <div className="form__group col col-lrg-2">
                                                    <div className="form__group__label">Generate Documents:</div>
                                                    <div className="u-flex--default btn--grouped">
                                                        <BaasicButton
                                                            onlyIcon={true}
                                                            className='btn btn--sml btn--light t u-mar--right--tny'
                                                            label='SWO & PN'
                                                            icon="u-icon u-icon--sml u-icon--download--brand"
                                                            onClick={() => generateMedicalNecessityFormAndStandardWrittenOrder()}
                                                        />
                                                        <BaasicButton
                                                            className='btn btn--sml btn--light t u-mar--right--tny'
                                                            label='SWO'
                                                            onClick={() => generateStandardWrittenOrder()}
                                                        />
                                                        <BaasicButton
                                                            className='btn btn--sml btn--light t u-mar--right--tny'
                                                            label='PN'
                                                            onClick={() => generateMedicalNecessityForm()}
                                                        />
                                                        <FacilityOrderTemplateNewFlowCustomOrderingDoctorAdd facilityOrderTemplate={facilityOrderTemplate} className="u-mar--left--sml" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col col-lrg-4">
                                                    <div className="row">
                                                        <div className="form__group col col-lrg-8">
                                                            <BaasicFieldDropdown field={form.$('orderingDoctorId')} store={doctorStore} allowEmpty={true} />
                                                        </div>
                                                        <div className="col col-lrg-2">
                                                            <NumericInputField field={form.$('height')} showSpinners={false} setDefaultType={true} onBlur={() => { updatePatient('height') }} />
                                                        </div>
                                                        <div className="col col-lrg-2">
                                                            <NumericInputField field={form.$('weight')} showSpinners={false} setDefaultType={true} onBlur={() => { updatePatient('weight') }} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col col-lrg-1">
                                                    <BaasicFieldDropdown field={form.$('dxCode1')} store={dxCode1Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} />
                                                </div>
                                                <div className="col col-lrg-1">
                                                    <BaasicFieldDropdown field={form.$('dxCode2')} store={dxCode2Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} />
                                                </div>
                                                <div className="col col-lrg-1">
                                                    <BaasicFieldDropdown field={form.$('dxCode3')} store={dxCode3Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} />
                                                </div>
                                                <div className="col col-lrg-1">
                                                    <BaasicFieldDropdown field={form.$('dxCode4')} store={dxCode4Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} />
                                                </div>
                                                <div className="col col-lrg-1">
                                                    <BaasicFieldDropdown field={form.$('dxCode5')} store={dxCode5Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} />
                                                </div>
                                                <div className="col col-lrg-1">
                                                    <BaasicFieldDropdown field={form.$('dxCode6')} store={dxCode6Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} />
                                                </div>
                                                <div className="col col-lrg-1">
                                                    <BaasicFieldDropdown field={form.$('dxCode7')} store={dxCode7Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} />
                                                </div>
                                                <div className="col col-lrg-1">
                                                    <BaasicFieldDropdown field={form.$('dxCode8')} store={dxCode8Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} />
                                                </div>
                                            </div>
                                        </React.Fragment>
                                        :
                                        <a className={`u-anchor--sml--underline ${isItemVisible ? "u-mar--top--med" : ""}`} onClick={() => changeItemVisibility()}> {isItemVisible ? "Show less" : "Show all"}</a>
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {isItemVisible && item.facilityOrderTemplateItems.map((facilityOrderTemplateItem) => {
                                return (
                                    <tr key={facilityOrderTemplateItem.id}>
                                        <td>
                                            {facilityOrderTemplateItem.product && facilityOrderTemplateItem.product.description}
                                        </td>
                                        <td>
                                            {facilityOrderTemplateItem.product && facilityOrderTemplateItem.product.itemId}
                                        </td>
                                        <td className="table-col-input text-align-left">
                                            {
                                                <input
                                                    className="input--table input--inherit-color no-arrows input--text-align--left"
                                                    onClick={null}
                                                    value={facilityOrderTemplateItem.templateQuantity}
                                                    defaultValue={facilityOrderTemplateItem.templateQuantity}
                                                    disabled={true}
                                                />
                                            }
                                        </td>
                                        <td className="table-col-input">
                                            <input
                                                className="input--table input--inherit-color no-arrows input--text-align--left"
                                                onClick={null}
                                                value={facilityOrderTemplateItem.note}
                                                defaultValue={facilityOrderTemplateItem.note}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {isItemVisible &&
                        <div>
                            <a className={`u-anchor--sml--underline ${isItemVisible ? "u-mar--top--med" : ""}`} onClick={() => changeItemVisibility()}><u>{isItemVisible ? "Show less" : "Show all"}</u></a>
                        </div>
                    }
                    <BaasicModal modalParams={facilityOrderTemplateMissingDocumentNoteModal}>
                        <FacilityOrderTemplateMissingDocumentNoteModal />
                    </BaasicModal>
                    <BaasicModal modalParams={facilityOrderTemplatePNMissingInformationModal} className="modal__content modal--med">
                        <FacilityOrderTemplatePNMissingInformationModal />
                    </BaasicModal>
                </React.Fragment>
            }
        </Content>
    )
}

PatientMissingDocsTemplateEditTemplate.propTypes = {
    patientMissingDocsTemplateEditViewStore: PropTypes.object.isRequired,
    showAdditionalData: PropTypes.bool
};

export default defaultTemplate(PatientMissingDocsTemplateEditTemplate);